module.exports = __webpack_public_path__ + "static/src/content/images/processed/600/16_9.87e763b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/600/16_9.jpg
// module id = VqNe
// module chunks = 1